import clsx from 'clsx'
import Map from '@/src/components/elements/Map'

export default function SquareMap({
  rounded = '5',
  ...props
}: { rounded?: '5' | '2xl' } & Parameters<typeof Map>[0]) {
  const className = clsx(props.className, 'h-full w-full')
  return (
    <div
      className={clsx([
        'aspect-w-1 relative w-full overflow-hidden aspect-h-1',
        {
          'rounded-[5px]': rounded === '5',
          'rounded-2xl': rounded === '2xl',
        },
      ])}
    >
      <div>
        <Map {...props} className={className} />
      </div>
    </div>
  )
}
